/* WISAMIN — product description formatter
   Converts the flat <p>/<strong>✅ description into the .wp-ar article layout.
   Safe: if anything looks unexpected it leaves the original markup alone. */
(function () {
  'use strict';

  var ICONS = {
    spec:  'M4 5h16M4 12h16M4 19h10',
    box:   'M3 7l9-4 9 4v10l-9 4-9-4z M3 7l9 4 9-4 M12 11v10',
    cert:  'M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.4 6.8 19.1l1-5.8L3.5 9.2l5.9-.9z',
    shield:'M12 3l7 3v6c0 4.2-2.9 7.6-7 9-4.1-1.4-7-4.8-7-9V6z M9 12l2 2 4-4',
    leaf:  'M5 19c0-8 5-13 14-13 0 9-5 14-13 14 0-4 2-7 6-9',
    flask: 'M9 3h6 M10 3v6l-5 9a2 2 0 002 3h10a2 2 0 002-3l-5-9V3 M7.5 15h9',
    heart: 'M12 20s-7-4.3-7-9a4 4 0 017-2.6A4 4 0 0119 11c0 4.7-7 9-7 9z',
    cup:   'M6 4h10v6a5 5 0 01-10 0z M16 6h2a2 2 0 010 4h-2 M5 20h12',
    clock: 'M12 21a9 9 0 100-18 9 9 0 000 18z M12 7v5l3 2',
    warn:  'M12 4l9 16H3z M12 10v4 M12 17h.01',
    info:  'M12 21a9 9 0 100-18 9 9 0 000 18z M12 11v5 M12 8h.01',
    gut:   'M6 4c0 4 12 4 12 8s-12 4-12 8',
    star:  'M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.4 6.8 19.1l1-5.8L3.5 9.2l5.9-.9z'
  };

  var RULES = [
    [/warn|caution|not suitable|avoid|side effect|allerg/i, 'warn',  'warn'],
    [/store|storage|keep in|shelf life|expiry/i,            'clock', 'misc'],
    [/how to|directions|suggested use|recommended intake|serving suggestion|preparation/i, 'cup', 'how'],
    [/halal|certif|fda|gmp|sgs|iso|haccp|registration/i,    'cert',  'cert'],
    [/ingredient|composition|blend|contains|formula/i,      'flask', 'ing'],
    [/probiotic|prebiotic|gut|digest|fib(re|er)/i,          'gut',   'misc'],
    [/benefit|highlight|why choose|advantage|key feature/i, 'star',  'feat'],
    [/nutrition|protein|amino|vitamin|mineral|calorie/i,    'leaf',  'misc'],
    [/weight|quantity|size|serving|net|package|packing/i,   'box',   'spec'],
    [/overview|detail|specification|product info/i,         'spec',  'spec'],
    [/flavor|flavour|taste/i,                               'heart', 'misc']
  ];

  function pick(title) {
    for (var i = 0; i < RULES.length; i++) if (RULES[i][0].test(title)) return { icon: RULES[i][1], mod: RULES[i][2] };
    return { icon: 'info', mod: 'misc' };
  }

  function svg(key) {
    var d = ICONS[key] || ICONS.info;
    var paths = d.split(' M').map(function (p, i) { return '<path d="' + (i ? 'M' + p : p) + '"/>'; }).join('');
    return '<span class="wp-ar__hi"><svg viewBox="0 0 24 24" aria-hidden="true">' + paths + '</svg></span>';
  }

  function txt(el) { return (el.textContent || '').replace(/ /g, ' ').trim(); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  // "Key : Value" -> [key, value]  (only when the key is short and label-like)
  function kv(s) {
    var m = s.match(/^([^:]{2,42}?)\s*[:：]\s*(.+)$/);
    if (!m) return null;
    if (/\d{2,}$/.test(m[1])) return null;
    return [m[1].trim(), m[2].trim()];
  }

  /* Flatten the description into an ordered list of lines and images,
     whatever wrapper markup Shopify's editor happened to leave behind. */
  function tokenise(root) {
    var BLOCK = /^(P|DIV|LI|UL|OL|H1|H2|H3|H4|H5|H6|SECTION|ARTICLE|TABLE|TR|BLOCKQUOTE|FIGURE)$/;
    var out = [];
    var buf = '';
    var seenImg = {};

    function flushLine() {
      var t = buf.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
      buf = '';
      if (!t) return;
      if (!/[A-Za-z0-9\u0e00-\u0e7f]/.test(t)) return;
      out.push({ k: 'line', t: t });
    }

    function walk(node) {
      for (var i = 0; i < node.childNodes.length; i++) {
        var n = node.childNodes[i];
        if (n.nodeType === 3) { buf += n.nodeValue; continue; }
        if (n.nodeType !== 1) continue;
        var tag = n.tagName;
        if (tag === 'BR') { flushLine(); continue; }
        if (tag === 'IMG') {
          flushLine();
          var src = (n.getAttribute('src') || '').split('?')[0];
          if (src && seenImg[src]) continue;
          if (src) seenImg[src] = 1;
          out.push({ k: 'img', el: n });
          continue;
        }
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'IFRAME') continue;
        if (BLOCK.test(tag)) { flushLine(); walk(n); flushLine(); continue; }
        walk(n);                                  // strong, b, em, span, a ...
      }
    }
    walk(root);
    flushLine();
    return out;
  }

  function build(root) {
    var raw = tokenise(root);
    if (!raw.length) return null;

    /* classify each line */
    var toks = [];
    raw.forEach(function (x) {
      if (x.k === 'img') { toks.push(x); return; }
      var t = x.t;
      if (/^[\u2705\u2714\u2611\u2713\u25A0\u25CF\u2726\u2B50]/.test(t)) {
        var body = t.replace(/^[\u2705\u2714\u2611\u2713\u25A0\u25CF\u2726\u2B50\ufe0f\s]+/, '').trim();
        if (!body) return;
        var words = body.split(/\s+/).length;
        var shouty = /^[^a-z]{6,}$/.test(body);          // ALL-CAPS product line
        var isHeading = !/[.!?]$/.test(body) &&
          ((body.length <= 78 && words <= 14) || (shouty && body.length <= 120));
        toks.push({ k: isHeading ? 'h' : 'check', t: body.replace(/\s*[:\uff1a]\s*$/, '') });
        return;
      }
      if (/^[-\u2013\u2014\u2022\u00b7\u25aa\u25cb]\s*/.test(t)) {
        var it = t.replace(/^[-\u2013\u2014\u2022\u00b7\u25aa\u25cb]\s*/, '').trim();
        if (it) toks.push({ k: 'li', t: it });
        return;
      }
      toks.push({ k: 'p', t: t });
    });
    if (!toks.some(function (x) { return x.k === 'h'; })) return null;

    var out = document.createElement('div');
    out.className = 'wp-ar';
    var figs = [];
    var secs = [];
    var cur = null;
    var leadDone = false;
    function flush() { if (cur) { secs.push(cur); cur = null; } }

    toks.forEach(function (x) {
      if (x.k === 'img') { figs.push(x.el); return; }
      if (x.k === 'h') {
        var empty = !cur || (!cur.title && !cur.items.length && !cur.checks.length && !cur.paras.length);
        if (!leadDone && !secs.length && empty) { cur = null; 
          var p = document.createElement('p');
          p.className = 'wp-ar__lead';
          p.textContent = x.t;
          out.appendChild(p);
          leadDone = true;
          return;
        }
        flush();
        cur = { title: x.t, items: [], checks: [], paras: [] };
        return;
      }
      if (!cur) cur = { title: '', items: [], checks: [], paras: [] };
      if (x.k === 'li') cur.items.push(x.t);
      else if (x.k === 'check') cur.checks.push(x.t);
      else cur.paras.push(x.t);
    });
    flush();
    secs = secs.filter(function (s) { return s.title || s.items.length || s.checks.length || s.paras.length; });
    if (!secs.length) return null;

    if (figs.length) {
      var f = document.createElement('figure');
      f.className = 'wp-ar__fig';
      f.appendChild(figs.shift().cloneNode(true));
      out.appendChild(f);
    }
    var every = figs.length ? Math.max(2, Math.ceil(secs.length / (figs.length + 1))) : 0;

    secs.forEach(function (s, idx) {
      var meta = pick(s.title || '');
      var sec = document.createElement('section');
      sec.className = 'wp-ar__s wp-ar__s--' + meta.mod;
      if (s.title) {
        var h = document.createElement('h3');
        h.className = 'wp-ar__h';
        h.innerHTML = svg(meta.icon) + '<span>' + esc(s.title) + '</span>';
        sec.appendChild(h);
      }
      s.paras.forEach(function (p) {
        var el = document.createElement('p');
        el.textContent = p;
        sec.appendChild(el);
      });
      if (s.items.length) {
        var pairs = s.items.map(kv);
        var nPair = pairs.filter(Boolean).length;
        if (nPair >= 2 && nPair >= Math.ceil(s.items.length * 0.6)) {
          var tb = document.createElement('table');
          tb.className = 'wp-ar__spec';
          var tbody = document.createElement('tbody');
          s.items.forEach(function (it, i) {
            var tr = document.createElement('tr');
            if (pairs[i]) tr.innerHTML = '<th>' + esc(pairs[i][0]) + '</th><td>' + esc(pairs[i][1]) + '</td>';
            else tr.innerHTML = '<td colspan="2">' + esc(it) + '</td>';
            tbody.appendChild(tr);
          });
          tb.appendChild(tbody);
          sec.appendChild(tb);
        } else {
          var longest = Math.max.apply(null, s.items.map(function (i) { return i.length; }));
          var ul = document.createElement('ul');
          ul.className = (s.items.length >= 4 && longest <= 58) ? 'wp-ar__feat' : 'wp-ar__dots';
          s.items.forEach(function (it) {
            var li = document.createElement('li');
            li.textContent = it;
            ul.appendChild(li);
          });
          sec.appendChild(ul);
        }
      }
      if (s.checks.length) {
        var short = s.checks.every(function (c) { return c.length <= 46; });
        var ulc = document.createElement('ul');
        ulc.className = short ? 'wp-ar__badges' : 'wp-ar__feat';
        s.checks.forEach(function (c) {
          var li = document.createElement('li');
          li.textContent = c;
          ulc.appendChild(li);
        });
        sec.appendChild(ulc);
      }
      out.appendChild(sec);
      if (every && figs.length && (idx + 1) % every === 0) {
        var fg = document.createElement('figure');
        fg.className = 'wp-ar__fig';
        fg.appendChild(figs.shift().cloneNode(true));
        out.appendChild(fg);
      }
    });
    while (figs.length) {
      var fl = document.createElement('figure');
      fl.className = 'wp-ar__fig';
      fl.appendChild(figs.shift().cloneNode(true));
      out.appendChild(fl);
    }
    Array.prototype.forEach.call(out.querySelectorAll('img'), function (im) {
      im.setAttribute('loading', 'lazy');
      im.removeAttribute('height');
      im.removeAttribute('width');
      if (!im.getAttribute('alt')) im.setAttribute('alt', (document.title || '').split('|')[0].trim());
    });
    return out;
  }

  function run() {
    var hosts = document.querySelectorAll('.wp-pdp__rte:not([data-arfmt])');
    Array.prototype.forEach.call(hosts, function (host) {
      host.setAttribute('data-arfmt', '1');
      try {
        var built = build(host);
        if (built) { host.innerHTML = ''; host.appendChild(built); }
      } catch (e) { /* leave the original description untouched */ }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
